export function PastTournamentBadge() {
  return (
    <div className="inline-block h-[24px] rounded border border-orange/50 bg-past-tournament-badge px-6 text-orange text-sm">
      Past
    </div>
  );
}
